<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="400" min-height="100">
          <v-card-text class="text-h5 pb-0">
            {{ stripeStatusText() }}
          </v-card-text>
          <v-card-text class="text-h5 pb-0">
            <v-btn v-if="stripeStatus != 'loading'" class="ml-14 main-btn success-green" text @click="stripeLink()">
              {{ stripeButtonText() }}
            </v-btn>
          </v-card-text>
          <v-card-text class="text-h5 pb-0" v-if="stripeStatus != 'loading' && stripeStatus != 'not_found' && false">
            <v-btn outlined rounded color="primary" dark class="ml-14" @click="deleteStripeAccountDialog = true"
              >Delete Stripe Account</v-btn
            >
          </v-card-text>
          <v-card-text class="text-h5 pb-0" v-if="stripeStatus != 'loading' && stripeStatus != 'not_found'">
            <v-btn outlined rounded color="primary" dark class="ml-14" @click="stripeLoginLink"
              >Login to Dashboard</v-btn
            >
          </v-card-text>
          <v-card-text>
            <v-alert v-if="error" type="error">
              {{ error }}
            </v-alert>
          </v-card-text>
        </v-card>
        <v-dialog v-model="deleteStripeAccountDialog">
          <v-card>
            <v-card-title class="headline"> Delete Stripe Account? </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                class="mr-4"
                text
                @click="((deleteStripeAccountDialog = false), deleteStripeAccount())"
              >
                Delete
              </v-btn>
              <v-btn class="mr-4 main-btn" outlined color="gray" text @click="deleteStripeAccountDialog = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */

import API from '../../api';

export default {
  name: 'StripeAccount',

  data: () => ({
    //    tags: [],
    error: null,
    sent: false,
    deleteStripeAccountDialog: false,
    stripeStatus: 'loading'
  }),
  mounted() {
    document.title = 'Stripe Account';
  },
  created: async function () {
    let res = await API.post('stripe/account-status', {});
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
      return;
    }
    this.stripeStatus = res.data.status;
    //this.loadData(this.appointmentUuid);
    //window.location.href = res.data.url;
  },
  methods: {
    stripeStatusText() {
      if (this.stripeStatus == 'loading') {
        return 'Loading..';
      } else if (this.stripeStatus == 'not_found') {
        return 'Stripe account is not connected..';
      } else if (this.stripeStatus == 'disabled') {
        return 'Stripe Account Setup is not completed..';
      } else {
        return 'Stripe Payments are enabled.';
      }
    },
    stripeButtonText() {
      if (this.stripeStatus == 'loading') {
        return 'Loading..';
      } else if (this.stripeStatus == 'not_found') {
        return 'Setup Stripe account';
      } else if (this.stripeStatus == 'disabled') {
        return 'Continue Stripe Setup';
      } else {
        return 'Manage Stripe Account';
      }
    },
    stripeLink: async function () {
      let res = await API.post('stripe/create-account', {});
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
        return;
      }
      window.location.href = res.data.url;
    },
    stripeLoginLink: async function () {
      try {
        console.log('Calling stripe/create-login-link API...');
        let res = await API.post('stripe/create-login-link', {});

        // Debug: Log the entire response
        console.log('Full API Response:', res);
        console.log('Response data:', res.data);
        console.log('Response data type:', typeof res.data);

        // Check for errors
        if (res.errors && res.errors.length > 0) {
          console.error('API returned errors:', res.errors);
          this.error = res.errors[0].msg;
          return;
        }

        // The backend is logging loginLink.url, so check all possible structures
        let loginUrl = null;

        // Try different response structures
        if (res.data && typeof res.data === 'object') {
          loginUrl = res.data.url || res.data.loginLink?.url || res.data.link || (res.data.data && res.data.data.url);
        } else if (typeof res.data === 'string') {
          loginUrl = res.data;
        }

        console.log('Extracted login URL:', loginUrl);

        if (!loginUrl) {
          console.error('Login URL not found in response. Response structure:', JSON.stringify(res, null, 2));
          this.error = 'Unable to retrieve Stripe login link. Please check console for details.';
          return;
        }

        console.log('Redirecting to:', loginUrl);
        window.location.href = loginUrl;
      } catch (error) {
        console.error('Exception in stripeLoginLink:', error);
        console.error('Error details:', error.response || error.message);
        this.error = 'An error occurred while getting the Stripe login link.';
      }
    },
    deleteStripeAccount: async function () {
      let res = await API.post('stripe/delete-account', {});
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
        return;
      }
    }
  }
};
</script>
<style></style>
